export default __webpack_public_path__ + "static/media/img-0708-belgium-full-face.b2b86c44.png";